/* Glitter Gurl box (Black November v2, Ali 2026-11-03).
   One idea on screen: "buy 2, get 2 free, mix any 4". One tray at the bottom, one bag sheet,
   one way to mix (the product rows). The checkout rule is unchanged and lives in the
   discount function: from 3 items half the bag is free, max 5. We never label which items
   are free, we show the count, the total and the saving. */
(function () {
  if (!window.GG_BOX) return;
  var ORDER = ['glitter-jelly-lip-gloss', 'lip-stain-marker', 'glitter-mascara', 'jelly-glow-eyeshadow', 'glitter-eyeliner', 'multichrome-eyeshadow-stick'];
  var DESC = {
    'glitter-jelly-lip-gloss': 'glassy jelly shine, packed with sparkle ✦ never sticky',
    'lip-stain-marker': 'teardrop-tip lip stain ✦ all-day, no transfer',
    'glitter-mascara': 'glitter over your mascara ✦ zero fallout',
    'jelly-glow-eyeshadow': 'one-swipe jelly glitter for lids ✦ no creasing',
    'glitter-eyeliner': 'liquid glitter liner ✦ sharp line, no smudge',
    'multichrome-eyeshadow-stick': 'creamy stick that shifts colour in the light'
  };
  var TABS = {
    eyes: ['glitter-mascara', 'jelly-glow-eyeshadow', 'glitter-eyeliner', 'multichrome-eyeshadow-stick'],
    lips: ['glitter-jelly-lip-gloss', 'lip-stain-marker']
  };
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ggx-filter]');
    if (!t) return;
    var tab = t.getAttribute('data-ggx-filter');
    t.parentNode.querySelectorAll('[data-ggx-filter]').forEach(function (b) { b.classList.toggle('on', b === t); });
    document.querySelectorAll('[data-ggx-rows]').forEach(function (b) { if (tab === 'all') b.removeAttribute('data-tab'); else b.setAttribute('data-tab', tab); });
    drawRows();
  });
  var GIFT_MIN = 6000, SHIP_MIN = 5000, SHIP = 400;
  var BUILD = '/pages/build-your-bag';
  var cart = null;
  var money = function (c) { return window.GG && GG.money ? GG.money(c) : '$' + (c / 100); };
  function shop() { return (window.GG_SHOP && GG_SHOP.products) || {}; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function isPdp() { return !!document.getElementById('gg-product-data') && !!document.querySelector('button[data-gg-cta]'); }

  /* the same maths the checkout runs */
  // mystery items: price (cents) -> variant id; a set of their ids so they never count as her items
  var MYSMAP = window.GG_MYSTERY || {}, MYSIDS = {};
  Object.keys(MYSMAP).forEach(function (k) { MYSIDS[MYSMAP[k]] = +k; });
  var MYS_ON = !!window.GG_MYSTERY_READY && Object.keys(MYSMAP).length > 0;
  function isMys(it) { return !!MYSIDS[it.variant_id]; }
  function units(c) {
    var u = [];
    ((c && c.items) || []).forEach(function (it) { if (it.price > 0 && !isMys(it)) for (var q = 0; q < it.quantity; q++) u.push(it.price); });
    return u;
  }
  // how many free mystery items she is owed if she checks out right now (Ali 2026-11-04)
  function mysFor(n) { return MYS_ON ? ({ 2: 2, 3: 1, 5: 1 })[n] || 0 : 0; }
  // which ones: the cheapest product line she does not have, then the next cheapest (Ali's rule)
  function mysPicks(k) {
    if (!k) return [];
    var have = {}, P = shop();
    ((cart && cart.items) || []).forEach(function (it) { if (!isMys(it)) have[it.handle] = 1; });
    var lines = ORDER.filter(function (h) { return P[h] && (P[h].variants || []).some(function (v) { return v.available; }); })
      .sort(function (a, b) { return P[a].price - P[b].price; });
    var not = lines.filter(function (h) { return !have[h]; });
    if (!not.length) not = lines;
    var out = [];
    for (var i = 0; i < k && not.length; i++) {
      var h = not[i % not.length], price = P[h].price;
      if (MYSMAP[String(price)]) out.push({ h: h, price: price, id: MYSMAP[String(price)] });
    }
    return out;
  }
  // the bag maths once mystery items are in: they are free first, then her cheapest (same as checkout)
  function calcM(own, mys) {
    var n = own.length + mys.length, free = n >= 3 ? Math.min(Math.floor(n / 2), 5) : 0;
    var worth = own.concat(mys).reduce(function (s, x) { return s + x; }, 0);
    var order = mys.slice().sort(function (a, b) { return a - b; }).concat(own.slice().sort(function (a, b) { return a - b; }));
    var save = order.slice(0, free).reduce(function (s, x) { return s + x; }, 0);
    return { n: n, free: free, worth: worth, save: save, pay: worth - save };
  }
  function calc(c) {
    var p = units(c), n = p.length, free = n >= 3 ? Math.min(Math.floor(n / 2), 5) : 0;
    var worth = p.reduce(function (s, x) { return s + x; }, 0);
    var save = p.slice().sort(function (a, b) { return a - b; }).slice(0, free).reduce(function (s, x) { return s + x; }, 0);
    return { n: n, free: free, worth: worth, save: save, pay: worth - save };
  }
  window.GG_BOX_CALC = calc;

  /* the words. Count to 4 first, then the next even step. Never "the next item is free". */
  function goal(n) { return n < 4 ? 4 : Math.min(10, n % 2 ? n + 1 : n); }
  function shipOf(r) { return r.pay >= SHIP_MIN ? 0 : SHIP; }
  function saved(r) { return r.save + (r.n && r.pay >= SHIP_MIN ? SHIP : 0); }
  // free delivery is only promised when the 2 extra items are sure to get her there, even at the cheapest picks
  function shipSure(c) {
    var r = calc(c); if (!r.n || r.pay >= SHIP_MIN) return false;
    var P = shop(), min = Infinity;
    for (var h in P) if ((P[h].variants || []).some(function (v) { return v.available; })) min = Math.min(min, P[h].price);
    if (!isFinite(min)) return false;
    var p = units(c).concat([min, min]), n = p.length, free = Math.min(Math.floor(n / 2), 5);
    var srt = p.slice().sort(function (a, b) { return a - b; }), pay = 0;
    for (var i = free; i < n; i++) pay += srt[i];
    return pay >= SHIP_MIN;
  }
  function line(r) {
    var n = r.n;
    if (!n) return { big: 'buy 2, get 2 free', small: 'mix any 4 ✦ any product, any shade' };
    if (n >= 10) return { big: '5 free 🎉', small: 'the most per order, gurl ✦ you saved ' + money(saved(r)), done: true };
    if (n % 2 === 0 && n >= 4) return { big: 'buy ' + n / 2 + ', get ' + n / 2 + ' free 🎉', small: 'unlocked ✦ you saved ' + money(saved(r)), done: true };
    return { big: n + '/' + goal(n), small: more(n) };
  }
  // "add 1 more, get 2 free" is the buy 2 get 2 framing (Ali 2026-11-03): pay for one more, the next two are free
  function more(n) {
    if (n <= 0) return 'buy 2, get 2 free';
    if (n === 1) return 'add 1 more ✦ get 2 free 🎁';
    if (n === 2) return 'add 2 more ✦ they’re free 🎁';
    if (n === 3) return 'add 1 more ✦ get 2 free 🎁';
    if (n === 4) return 'add 1 more ✦ get 1 FREE 🎁' + (shipSure(cart) ? ' + free delivery 🚚' : '');
    if (n === 5) return 'don’t leave your 3rd free item behind 🎁';
    return '';   // the challenge stops at the 3rd free item
  }
  function dots(r) {
    var g = r.n >= 10 ? r.n : Math.max(goal(r.n), r.n), h = '';
    for (var i = 0; i < Math.min(g, 10); i++) h += '<i class="' + (i < r.n ? 'on' : '') + '"></i>';
    return '<span class="ggx-dots">' + h + '</span>';
  }
  function nudge(r) { return r.n >= 4 && r.n < 10 && r.n % 2 === 0 ? more(r.n) : ''; }

  /* cart plumbing: always go through the theme's own refresh, so the gift line syncs */
  // a cart that fails to load (bad signal, a busy moment) never leaves the page blank: draw with what we have, retry quietly
  var retries = 0;
  function refresh() {
    return (window.__ggCartRefresh ? window.__ggCartRefresh() : fetch('/cart.js').then(function (r) { return r.json(); }))
      .then(function (c) { if (!c || !c.items) throw new Error('bad cart'); cart = c; retries = 0; drawAll(); return c; })
      .catch(function () {
        if (!cart) cart = { items: [], total_price: 0 };
        drawAll();
        if (retries++ < 4) setTimeout(refresh, 1500 * retries);
        return cart;
      });
  }
  function add(id) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); }).then(refresh);
  }
  function setQty(key, q) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) }).then(refresh);
  }
  function findVariant(vid) {
    var P = shop();
    for (var h in P) { var vs = P[h].variants || []; for (var i = 0; i < vs.length; i++) if (vs[i].id === vid) return { h: h, p: P[h], v: vs[i] }; }
    return null;
  }

  /* toast */
  var toastT, toastLock = 0;
  function toast(msg, big) {
    // the unlock moments win over the plain "added" message that lands right after them
    if (!big && Date.now() < toastLock) return;
    if (big) toastLock = Date.now() + 2400;
    var t = document.getElementById('ggx-toast');
    if (!t) { t = document.createElement('div'); t.id = 'ggx-toast'; document.body.appendChild(t); }
    t.innerHTML = msg; t.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  /* ── the tray ── */
  var tray;
  function buildTray() {
    tray = document.createElement('div');
    tray.id = 'ggx-tray';
    document.body.appendChild(tray);
    document.body.classList.add('ggx-has-tray');
    tray.addEventListener('click', function (e) {
      var cta = e.target.closest('.ggx-t-cta');
      var r = calc(cart);
      if (cta && !r.n && isPdp()) {
        if (document.getElementById('ggx-pick')) { pickAdd(null); return; }
        var b = document.querySelector('button[data-gg-cta]:not([data-gg-cta-short])'); if (b) b.click(); return;
      }
      if (cta && r.n) { openBag(); return; }
      if (r.n) openBag();
      else if (isPdp()) { var rows = document.querySelector('[data-ggx-rows]'); var top = document.getElementById('gg-chips'); (top || rows).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }
  function drawTray() {
    if (!tray) return;
    var r = calc(cart), L = line(r), trSave = projSave(r);
    var show = r.n > 0 || isPdp();
    tray.hidden = !show;
    document.body.classList.toggle('ggx-has-tray', show);
    if (!show) return;
    tray.innerHTML = '<button type="button" class="ggx-t-left">' + dots(r) +
        '<span class="ggx-t-txt"><b>' + esc(L.big) + '</b><span>' + (mysFor(r.n) && trSave > 0 ? '🎁 ' + esc(String(r.n === 2 ? 2 : 1)) + ' free waiting ✦ save ' + money(trSave) : esc(L.small)) + '</span></span></button>' +
      '<button type="button" class="ggx-t-cta">' + (r.n ? 'my bag ✦ ' + money(r.pay) + ' →' + (trSave > 0 ? '<small>you save ' + money(trSave) + '</small>' : '') : 'add to my bag') + '</button>';
  }
  // what she saves right now: her own free items, or (at 2, 3, 5 items) the mystery gifts she'd get (Ali 2026-11-04)
  function projSave(r) {
    var mp = mysPicks(mysFor(r.n));
    if (!mp.length) return saved(r);
    var rm = calcM(units(cart), mp.map(function (m) { return m.price; }));
    return rm.save;
  }

  /* which units are free: Shopify's own per-line discount when it adds up, else the checkout rule */
  function freeByLine(c, want) {
    var m = {}, sum = 0;
    ((c && c.items) || []).forEach(function (it) {
      if (!(it.price > 0)) return;
      var d = it.line_level_total_discount != null ? it.line_level_total_discount : (it.total_discount || 0);
      var k = Math.min(it.quantity, Math.round(d / it.price));
      if (k) { m[it.key] = k; sum += k; }
    });
    if (sum === want) return m;
    m = {};
    var us = [];
    ((c && c.items) || []).forEach(function (it) { if (it.price > 0) for (var q = 0; q < it.quantity; q++) us.push({ key: it.key, p: it.price }); });
    us.map(function (u, i) { return { i: i, p: u.p }; }).sort(function (a, b) { return a.p - b.p || a.i - b.i; })
      .slice(0, want).forEach(function (x) { var k = us[x.i].key; m[k] = (m[k] || 0) + 1; });
    return m;
  }
  function priceCell(it, k) {
    var full = it.price * it.quantity;
    if (!k) return '<span class="ggx-it-p">' + money(full) + '</span>';
    if (k >= it.quantity) return '<span class="ggx-it-p is-free"><s>' + money(full) + '</s><b>FREE</b></span>';
    return '<span class="ggx-it-p is-part"><s>' + money(full) + '</s><b>' + money(full - k * it.price) + '</b><em>' + k + ' free</em></span>';
  }

  /* ── the bag sheet ── */
  var sheet;
  function openBag() {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.id = 'ggx-sheet';
      sheet.innerHTML = '<div class="ggx-sh-bg"></div><div class="ggx-sh-panel" role="dialog" aria-label="your bag"><button type="button" class="ggx-sh-x" aria-label="close">✕</button><div class="ggx-sh-body"></div></div>';
      document.body.appendChild(sheet);
      sheet.querySelector('.ggx-sh-bg').onclick = closeBag;
      sheet.querySelector('.ggx-sh-x').onclick = closeBag;
      sheet.addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]');
        if (b) { b.disabled = true; setQty(b.getAttribute('data-key'), +b.getAttribute('data-q')); return; }
        if (e.target.closest('.ggx-keep')) { e.preventDefault(); keepPicking(); return; }
        var go = e.target.closest('.ggx-order');
        if (go && +go.getAttribute('data-mys')) { checkoutWithMystery(go, mysPicks(+go.getAttribute('data-mys'))); return; }
        if (go) gateCheckout(go);
        if (e.target.closest('.ggx-choose')) { closeBag(); goPick(); }
      });
    }
    drawBag();
    sheet.classList.add('on');
    lockPage();
  }
  function closeBag() { if (sheet) sheet.classList.remove('on'); unlockPage(); }
  /* iPhone ignores overflow:hidden on the page, so freeze it in place while a panel is open */
  var lockY = null;
  function lockPage() {
    if (lockY !== null) return;
    lockY = window.scrollY;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('ggx-lock');
  }
  function unlockPage() {
    if (lockY === null) return;
    if ((sheet && sheet.classList.contains('on')) || (pv && pv.classList.contains('on'))) return;
    var b = document.body.style, y = lockY;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    document.documentElement.classList.remove('ggx-lock');
    lockY = null; window.scrollTo(0, y);
  }
  function keepPicking() {
    closeBag();
    var rows = document.querySelector('[data-ggx-rows]');
    if (rows) rows.scrollIntoView({ behavior: 'smooth', block: 'start' });
    else window.location.href = BUILD;
  }
  function drawBag() {
    if (!sheet) return;
    var body = sheet.querySelector('.ggx-sh-body');
    var r = calc(cart), L = line(r);
    if (!r.n) {
      body.innerHTML = '<div class="ggx-sh-h">your bag ✦</div><div class="ggx-sh-empty"><b>buy 2, get 2 free</b><span>mix any 4 ✦ any product, any shade</span></div>' +
        '<a href="' + BUILD + '" class="gg-btn ggx-keep" style="width:100%">start picking →</a>';
      return;
    }
    var mp = mysPicks(mysFor(r.n)), k = mp.length, rm = k ? calcM(units(cart), mp.map(function (m) { return m.price; })) : r;
    var rows = '', gift = false, fr = freeByLine(cart, r.free), paidRowsAcc = [], freeRowsAcc = [];
    (cart.items || []).forEach(function (it) {
      if (!(it.price > 0)) { gift = true; return; }
      if (isMys(it)) return;
      var f = findVariant(it.variant_id), chip = f && f.v.chip, name = f ? f.p.title : it.product_title, shade = f ? f.v.title : it.variant_title;
      var isFree = (fr[it.key] || 0) >= it.quantity;
      // paid items first, free ones grouped together underneath (Ali 2026-11-04)
      (isFree ? freeRowsAcc : paidRowsAcc).push('<div class="ggx-it' + (isFree ? ' ggx-free' : '') + '">' +
        '<span class="ggx-it-sw"' + (chip ? ' style="background-image:url(\'' + esc(chip) + '\')"' : '') + '></span>' +
        '<span class="ggx-it-t"><b>' + esc(shade) + '</b><span>' + esc(String(name).toLowerCase()) + '</span></span>' +
        '<span class="ggx-it-q"><button type="button" data-key="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="one less">−</button><b>' + it.quantity + '</b>' +
        '<button type="button" data-key="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="one more">+</button></span>' +
        priceCell(it, fr[it.key] || 0) + '</div>');
    });
    rows = paidRowsAcc.join('') + freeRowsAcc.join('');
    mp.forEach(function (m) { rows += '<div class="ggx-it ggx-mys"><span class="ggx-it-sw">🎁</span><span class="ggx-it-t"><b>mystery item ✦ our pick</b><span>a free surprise, on us</span></span><span class="ggx-it-p is-free"><s>' + money(m.price) + '</s><b>FREE</b></span></div>'; });
    var ship = r.pay >= SHIP_MIN ? 0 : SHIP;
    var perks = '<div class="ggx-perk">' + (ship ? '🚚 ' + money(SHIP_MIN - r.pay) + ' away from free delivery' : '🚚 free delivery unlocked') + '</div>' +
      '<div class="ggx-perk">' + (r.pay >= GIFT_MIN || gift ? '🎁 your free full-size gift is in the bag' : '🎁 ' + money(GIFT_MIN - r.pay) + ' away from a free full-size gift') + '</div>';
    var nd = nudge(r);
    body.innerHTML =
      '<div class="ggx-sh-h">your bag ✦</div>' +
      (k ? '<div class="ggx-sh-prog ggx-mys-note">🎁 <span><b>' + k + ' free mystery item' + (k > 1 ? 's' : '') + ' added</b> ✦ or pick your own shades</span></div>'
         : '<div class="ggx-sh-prog">' + dots(r) + '<span><b>' + esc(L.big) + '</b> ' + esc(L.small) + '</span></div>') +
      '<div class="ggx-its">' + rows + (gift ? '<div class="ggx-it ggx-gift"><span class="ggx-it-sw">🎁</span><span class="ggx-it-t"><b>free full-size gift</b><span>a surprise from us</span></span><span class="ggx-it-p is-free"><b>FREE</b></span></div>' : '') + '</div>' +
      // the top bar already shows delivery + gift progress (Ali 2026-11-04)
      '<div class="ggx-sh-foot">' +
      // pinned totals (Ali 2026-11-04): full value + delivery crossed, the real total big, the saving underneath
      (function () {
        // delivery is only mentioned when one more item would make it free (Ali 2026-11-04)
        var showShip = ship && !k && r.n >= 4 && shipSure(cart);   // only beside "add 1 more + free delivery"
        var full = rm.worth + (ship ? (showShip ? SHIP : 0) : SHIP), total = rm.pay + (showShip ? ship : 0), saved = full - total;
        // one compact row (Ali 2026-11-04): the saving on the left, the total on the right
        return '<div class="ggx-ft">' +
          '<div class="ggx-ft-row">' +
            (saved > 0 ? '<span class="ggx-save-pill">🎉 you save ' + money(saved) + '</span>' : '<span class="ggx-ft-l">total</span>') +
            '<span class="ggx-ft-p">' + (saved > 0 ? '<s>' + money(full) + '</s>' : '') + '<b>' + money(total) + '</b></span>' +
          '</div>' +
          '<div class="ggx-ft-s">' + (ship ? (showShip ? money(ship) + ' delivery included ✦ ' : '') : 'free delivery 🚚 ✦ ') + 'cash on delivery</div>' +
        '</div>';
      })() +
      (k ? '<button type="button" class="gg-btn ggx-order" data-mys="' + k + '" style="width:100%">order now ✦ with my free gift' + (k > 1 ? 's' : '') + ' 🎁</button>' +
           '<button type="button" class="ggx-choose">no, I want to choose my free items</button>'
         : '<button type="button" class="gg-btn ggx-order" style="width:100%">order now ✦ pay on delivery →</button>' +
           '<a href="#" class="ggx-keep">' + (nd ? esc(nd) + ' →' : (L.done ? 'keep picking →' : esc(L.small) + ' ✦ keep picking →')) + '</a>') +
      '</div>';
  }

  /* ── the product rows: one way to mix, used under every product and on the mix page ── */
  var picked = {};
  function counts() { var m = {}; ((cart && cart.items) || []).forEach(function (it) { m[it.variant_id] = (m[it.variant_id] || 0) + it.quantity; }); return m; }
  function drawRows() {
    document.querySelectorAll('[data-ggx-rows]').forEach(function (box) {
      var ex = (box.getAttribute('data-exclude') || '').split(','), only = box.getAttribute('data-only');
      only = only ? only.split(',') : (TABS[box.getAttribute('data-tab')] || null);
      var P = shop(), cnt = counts(), html = '';
      ORDER.forEach(function (h) {
        if (!P[h] || ex.indexOf(h) >= 0 || (only && only.indexOf(h) < 0)) return;
        var p = P[h], vs = (p.variants || []).filter(function (v) { return v.available; });
        if (!vs.length) return;
        var sel = picked[h], sv = null;
        vs.forEach(function (v) { if (v.id === sel) sv = v; });
        var img = (sv && sv.worn) || p.image;
        html += '<div class="ggx-row" data-h="' + h + '">' +
          '<button type="button" class="ggx-row-img" data-prev="' + h + '" style="background-image:url(\'' + esc(img) + '\')" aria-label="see ' + esc(p.title) + '"><span>👀 tap to see</span></button>' +
          '<div class="ggx-row-main"><div class="ggx-row-top">' + (box.hasAttribute('data-links') ? '<a class="ggx-row-name" href="/products/' + h + '">' + esc(p.title) + ' ›</a>' : '<b>' + esc(p.title) + '</b>') + '<span>' + money(p.price) + '</span></div>' +
          (DESC[h] ? '<div class="ggx-row-d">' + esc(DESC[h]) + '</div>' : '') +
          '<div class="ggx-row-shade">' + (sv ? esc(sv.title) : 'pick a shade') + '</div>' +
          '<div class="ggx-row-chips">' + vs.map(function (v) {
            return '<button type="button" class="ggx-c' + (v.id === sel ? ' on' : '') + '" data-v="' + v.id + '" aria-label="' + esc(v.title) + '"' +
              (v.chip ? ' style="background-image:url(\'' + esc(v.chip) + '\')"' : '') + '>' + (cnt[v.id] ? '<i>' + cnt[v.id] + '</i><span class="ggx-pc-minus" role="button" aria-label="remove one ' + esc(v.title) + '" data-mv="' + v.id + '">−</span>' : '') + '</button>';
          }).join('') + '</div></div>' +
          '<button type="button" class="ggx-add' + (sv ? '' : ' off') + '" aria-label="add to my bag">+</button></div>';
      });
      box.innerHTML = html;
    });
  }
  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('.ggx-row');
    if (!row) return;
    if (e.target.closest('.ggx-pc-minus')) return;   // the minus handler takes it
    var h = row.getAttribute('data-h');
    if (e.target.closest('.ggx-row-img')) { openPrev(h); return; }
    var c = e.target.closest('.ggx-c');
    if (c) { picked[h] = +c.getAttribute('data-v'); drawRows(); return; }
    var a = e.target.closest('.ggx-add');
    if (!a) return;
    if (!picked[h]) { row.classList.remove('shake'); void row.offsetWidth; row.classList.add('shake'); toast('pick a shade first ✦'); return; }
    a.classList.add('busy'); a.textContent = '✦';
    var f = findVariant(picked[h]);
    add(picked[h]).then(function () {
      var r = calc(cart);
      toast('added ' + esc(f ? f.v.title : '') + ' ✦ <b>' + esc(line(r).big) + '</b>');
    }, function (er) { toast((er && er.description) || 'something went wrong, gurl. try again?'); drawRows(); });
  });

  /* ── the product page picker: tap a shade to see it, tap it again (or the button) to add it ── */
  var pick = { h: null, sel: null };
  function pdpHandle() { try { return JSON.parse(document.getElementById('gg-product-data').textContent).handle; } catch (e) { return null; } }
  function pdpVariants() { var p = shop()[pick.h]; return p ? (p.variants || []).filter(function (v) { return v.available; }) : []; }
  function showShade(v) {
    // drive the theme's own (hidden) shade chips, so the gallery switches to this shade
    document.querySelectorAll('#gg-chips > *').forEach(function (b) {
      if ((b.textContent || '').trim().toLowerCase() === String(v.title).toLowerCase()) b.click();
    });
  }
  function drawPick() {
    var box = document.querySelector('#ggx-pick .ggx-pick-body');
    if (!box || !pick.h) return;
    var vs = pdpVariants(), cnt = counts(), p = shop()[pick.h];
    if (!vs.length) { box.innerHTML = '<div class="ggx-pick-out">sold out for now, gurl ✦</div>'; return; }
    var sv = null; vs.forEach(function (v) { if (v.id === pick.sel) sv = v; });
    if (!sv) pick.sel = null;
    box.innerHTML =
      '<div class="ggx-pick-h">pick your shades</div>' +
      '<div class="ggx-pick-grid">' + vs.map(function (v) {
        return '<button type="button" class="ggx-pc' + (v.id === pick.sel ? ' on' : '') + '" data-pv="' + v.id + '">' +
          '<span class="ggx-pc-sw"' + (v.chip ? ' style="background-image:url(\'' + esc(v.chip) + '\')"' : '') + '>' + (cnt[v.id] ? '<i>' + cnt[v.id] + '</i><span class="ggx-pc-minus" role="button" aria-label="remove one ' + esc(v.title) + '" data-mv="' + v.id + '">−</span>' : '') + '</span>' +
          '<span class="ggx-pc-n">' + esc(v.title) + '</span></button>';
      }).join('') + '</div>' +
      (sv ? '<button type="button" class="gg-btn ggx-pick-add"><i class="ggx-sticker">save ' + money(2 * p.price) + '</i><b>+ add ' + esc(sv.title) + ' ✦ ' + money(p.price) + '</b><span>' + esc(more(calc(cart).n)) + '</span></button>'
          : '<button type="button" class="gg-btn ggx-pick-add is-empty"><i class="ggx-sticker">save ' + money(2 * p.price) + '</i><b>pick your shade ✦</b><span>' + esc(more(calc(cart).n)) + '</span></button>') +
      '<div class="ggx-pick-hint">tap a shade to see it ✦ tap it again to add it</div>' + mixStrip();
    drawView();
  }
  function pickAdd(btn) {
    var vid = pick.sel, f = findVariant(vid);
    if (!vid) {
      var g = document.querySelector('.ggx-pick-grid');
      if (g) { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); g.classList.remove('shake'); void g.offsetWidth; g.classList.add('shake'); }
      toast('pick your shade first ✦');
      return;
    }
    if (btn) { btn.disabled = true; btn.textContent = 'adding ✦'; }
    var cell = document.querySelector('.ggx-pc[data-pv="' + vid + '"]');
    if (cell) cell.classList.add('pop');
    add(vid).then(function () {
      toast('added ' + esc(f ? f.v.title : '') + ' ✦ <b>' + esc(line(calc(cart)).big) + '</b>');
    }, function (er) { toast((er && er.description) || 'something went wrong, gurl. try again?'); drawPick(); });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var m = e.target.closest('.ggx-pc-minus');
    if (m) {
      // added one by mistake: take one out right here, no trip to the bag
      var mv = +m.getAttribute('data-mv'), ln = null;
      ((cart && cart.items) || []).forEach(function (it) { if (it.variant_id === mv && !ln) ln = it; });
      if (ln) { m.style.opacity = '.4'; setQty(ln.key, ln.quantity - 1).then(function () { toast('removed one ✦ <b>' + esc(line(calc(cart)).big) + '</b>'); }); }
      return;
    }
    var c = e.target.closest('.ggx-pc');
    if (c) {
      var vid = +c.getAttribute('data-pv');
      if (vid === pick.sel) { pickAdd(null); return; }
      pick.sel = vid; drawPick();
      var f = findVariant(vid); if (f) showShade(f.v);
      return;
    }
    var b = e.target.closest('.ggx-pick-add');
    if (b) pickAdd(b);
  });
  function initPick() {
    if (!document.getElementById('ggx-pick')) return;
    pick.h = pdpHandle();
    // nothing preselected (Ali 2026-11-03): she picks, the gallery follows
  }
  /* view-only shade circles right under the photos: switch the gallery, and pre-pick in the picker */
  function drawView() {
    var box = document.getElementById('ggx-view');
    if (!box || !pick.h) return;
    var vs = pdpVariants();
    box.style.gridTemplateColumns = 'repeat(' + vs.length + ', 1fr)';
    box.innerHTML = vs.map(function (v) {
      return '<button type="button" class="ggx-vb' + (v.id === pick.sel ? ' on' : '') + '" data-vv="' + v.id + '" aria-label="see ' + esc(v.title) + '">' +
        '<span class="ggx-vc"' + (v.chip ? ' style="background-image:url(\'' + esc(v.chip) + '\')"' : '') + '></span>' +
        '<span class="ggx-vn">' + esc(v.title) + '</span></button>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ggx-vb');
    if (!b) return;
    pick.sel = +b.getAttribute('data-vv'); drawPick();
    var f = findVariant(pick.sel); if (f) { showShade(f.v); toast('<b>' + esc(f.v.title) + '</b> ✦ add it below ↓'); }
  });
  /* the other products, right under the add button: she sees she can mix */
  function mixStrip() {
    var P = shop(), h = '';
    ORDER.forEach(function (k) { if (k !== pick.h && P[k]) h += '<button type="button" class="ggx-mix-p" data-mix="' + k + '" style="background-image:url(\'' + esc(P[k].image) + '\')" aria-label="' + esc(P[k].title) + '"></button>'; });
    return h ? '<div class="ggx-mix"><div class="ggx-mix-t">mix it with any product ✦ they count too ↓</div><div class="ggx-mix-r">' + h + '</div></div>' : '';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ggx-mix-p');
    if (!b) return;
    var row = document.querySelector('.ggx-row[data-h="' + b.getAttribute('data-mix') + '"]');
    if (row) { row.scrollIntoView({ behavior: 'smooth', block: 'center' }); row.classList.remove('glow'); void row.offsetWidth; row.classList.add('glow'); }
  });

  /* quick look: a product's shade gallery without leaving the page */
  var prev = { h: null, sel: null }, pv;
  function galFor(v) {
    var out = [], seen = {};
    function push(x) {
      var src = typeof x === 'string' ? x : x && x.src; if (!src) return;
      var key = (x && x.video) ? x.video.split('?')[0] : src.split('?')[0];   // same photo at two sizes is one photo
      if (seen[key]) return; seen[key] = 1; out.push(typeof x === 'string' ? { src: x } : x);
    }
    if (v.worn) push(v.worn);
    (v.gallery || []).forEach(push);
    // the product's videos aren't tied to a shade: show them with every shade, second in line
    (vids[prev.h] || []).forEach(function (m, i) { var k = m.video.split('?')[0]; if (!seen[k]) { seen[k] = 1; out.splice(Math.min(1 + i, out.length), 0, m); } });
    return out;
  }
  var vids = {};
  function loadVids(h) {
    if (vids[h]) return Promise.resolve();
    return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (d) {
      var shades = ((shop()[h] || {}).variants || []).map(function (v) { return String(v.title).toLowerCase(); });
      vids[h] = (d.media || []).filter(function (m) {
        if (m.media_type !== 'video') return false;
        var alt = String(m.alt || '').toLowerCase();
        return !shades.some(function (t) { return alt.indexOf(t) === 0; });   // a shade's own video stays with that shade
      }).map(function (m) {
        var mp4 = (m.sources || []).filter(function (x) { return x.format === 'mp4'; }).sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
        var pick = mp4.filter(function (x) { return (x.height || 0) >= 480; })[0] || mp4[mp4.length - 1];
        return pick ? { src: (m.preview_image && m.preview_image.src) || '', video: pick.url } : null;
      }).filter(Boolean);
    }).catch(function () { vids[h] = []; });
  }
  function openPrev(h) {
    var P = shop()[h]; if (!P) return;
    if (!vids[h]) loadVids(h).then(function () { if (pv && pv.classList.contains('on') && prev.h === h) drawPrev(); });
    var vs = (P.variants || []).filter(function (v) { return v.available; });
    prev.h = h; prev.sel = picked[h] || (vs[0] && vs[0].id);
    if (!pv) {
      pv = document.createElement('div'); pv.id = 'ggx-pv';
      pv.innerHTML = '<div class="ggx-sh-bg"></div><div class="ggx-sh-panel"><button type="button" class="ggx-sh-x" aria-label="close">✕</button><div class="ggx-pv-body"></div></div>';
      document.body.appendChild(pv);
      pv.querySelector('.ggx-sh-bg').onclick = closePrev; pv.querySelector('.ggx-sh-x').onclick = closePrev;
      wireRoll();
      pv.addEventListener('click', function (e) {
        var mm = e.target.closest('.ggx-pc-minus');
        if (mm) {
          var mv = +mm.getAttribute('data-mv'), ln = null;
          ((cart && cart.items) || []).forEach(function (it) { if (it.variant_id === mv && !ln) ln = it; });
          if (ln) { mm.style.opacity = '.4'; setQty(ln.key, ln.quantity - 1).then(function () { drawPrev(); toast('removed one ✦ <b>' + esc(line(calc(cart)).big) + '</b>'); }); }
          e.stopPropagation(); return;
        }
        var c = e.target.closest('[data-pvv]');
        if (c) { prev.sel = +c.getAttribute('data-pvv'); picked[prev.h] = prev.sel; drawPrev(); drawRows(); return; }
        var a = e.target.closest('.ggx-pv-add');
        if (a) {
          a.disabled = true; a.textContent = 'adding ✦';
          var f = findVariant(prev.sel);
          add(prev.sel).then(function () {
            drawPrev();
            // the "added" moment: she stays, sees it worked, and can add another shade (Ali 2026-11-04)
            var b2 = pv.querySelector('.ggx-pv-add'), c2 = pv.querySelector('.ggx-c.on');
            if (c2) c2.classList.add('pop');
            if (b2) { b2.classList.add('done'); b2.innerHTML = '✓ ' + esc(f ? f.v.title : '') + ' added ✦ add another shade?'; setTimeout(function () { if (pv.classList.contains('on')) drawPrev(); }, 1800); }
          });
          return;
        }
        if (e.target.closest('.ggx-pv-done')) closePrev();
      });
    }
    drawPrev(); pv.classList.add('on'); lockPage();
  }
  function closePrev() {
    if (!pv) return;
    var pn = pv.querySelector('.ggx-sh-panel'); pn.style.transition = ''; pn.style.transform = '';
    pv.classList.remove('on'); unlockPage();
  }
  function wireRoll() {
    var pn = pv.querySelector('.ggx-sh-panel'), y0 = null, t0 = 0, dy = 0;
    pn.addEventListener('touchstart', function (e) {
      if (e.target.closest('.ggx-pv-gal')) { y0 = null; return; }   // the gallery swipes sideways
      y0 = e.touches[0].clientY; t0 = Date.now(); dy = 0; pn.style.transition = 'none';
    }, { passive: true });
    pn.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      e.preventDefault();
      pn.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    pn.addEventListener('touchend', function () {
      if (y0 === null) return;
      var v = dy / Math.max(1, Date.now() - t0);
      pn.style.transition = 'transform .25s ease';
      if (dy > 120 || (dy > 30 && v > 0.5)) { pn.style.transform = 'translateY(110%)'; setTimeout(closePrev, 220); }
      else pn.style.transform = '';
      y0 = null;
    });
  }
  /* the quick-look gallery: one photo at a time, swipe handled here so the page never moves */
  var gi = 0;
  function galGo(i) {
    var g = pv && pv.querySelector('.ggx-pv-gal'); if (!g) return;
    var n = g.querySelectorAll('.ggx-pv-track > *').length; if (!n) return;
    gi = Math.max(0, Math.min(n - 1, i));
    var tr = g.querySelector('.ggx-pv-track'), it = tr.children[gi];
    var maxX = Math.max(0, tr.scrollWidth - g.clientWidth);
    tr.style.transform = 'translateX(' + (-Math.min(it.offsetLeft, maxX)) + 'px)';
    g.querySelectorAll('.ggx-pv-ar').forEach(function (a) { a.style.visibility = (+a.getAttribute('data-gal') < 0 ? gi > 0 : gi < n - 1) ? 'visible' : 'hidden'; });
    g.querySelectorAll('.ggx-pv-dots i').forEach(function (d, k) { d.classList.toggle('on', k === gi); });
  }
  function wireGal() {
    var g = pv.querySelector('.ggx-pv-gal'); if (!g) return;
    gi = 0;
    var x0 = null, y0 = null, horiz = false;
    g.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; horiz = false; }, { passive: true });
    g.addEventListener('touchmove', function (e) {
      if (x0 === null) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (!horiz && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) horiz = true;
      if (horiz) e.preventDefault();
    }, { passive: false });
    g.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (horiz && Math.abs(dx) > 35) galGo(gi + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    g.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gal]'); if (a) { galGo(gi + (+a.getAttribute('data-gal'))); return; }
      var d = e.target.closest('.ggx-pv-dots i'); if (d) galGo([].indexOf.call(d.parentNode.children, d));
    });
  }
  function drawPrev() {
    if (!pv) return;
    var P = shop()[prev.h], vs = (P.variants || []).filter(function (v) { return v.available; }), cnt = counts(), sv = null;
    vs.forEach(function (v) { if (v.id === prev.sel) sv = v; });
    if (!sv) sv = vs[0];
    var G = galFor(sv);
    var gal = G.map(function (m) {
      return m.video ? '<video src="' + esc(m.video) + '" poster="' + esc(m.src) + '" muted loop playsinline autoplay></video>' : '<img src="' + esc(m.src) + '" alt="' + esc(sv.title) + '" loading="lazy">';
    }).join('');
    pv.querySelector('.ggx-pv-body').innerHTML =

      '<div class="ggx-pv-h"><b>' + esc(P.title) + '</b><span>' + money(P.price) + '</span></div>' +
      (DESC[prev.h] ? '<div class="ggx-pv-d">' + esc(DESC[prev.h]) + '</div>' : '') +
      '<div class="ggx-pv-gal"><div class="ggx-pv-track">' + gal + '</div>' +
        (G.length > 1 ? '<button type="button" class="ggx-pv-ar l" data-gal="-1" aria-label="previous">‹</button><button type="button" class="ggx-pv-ar r" data-gal="1" aria-label="next">›</button>' +
          '<div class="ggx-pv-dots">' + G.map(function (m, k) { return '<i class="' + (k ? '' : 'on') + '"></i>'; }).join('') + '</div>' : '') + '</div>' +
      '<div class="ggx-pv-sn">' + esc(sv.title) + '</div>' +
      '<div class="ggx-row-chips ggx-pv-chips">' + vs.map(function (v) {
        return '<button type="button" class="ggx-c' + (v.id === sv.id ? ' on' : '') + '" data-pvv="' + v.id + '" aria-label="' + esc(v.title) + '"' + (v.chip ? ' style="background-image:url(\'' + esc(v.chip) + '\')"' : '') + '>' + (cnt[v.id] ? '<i>' + cnt[v.id] + '</i><span class="ggx-pc-minus" role="button" aria-label="remove one ' + esc(v.title) + '" data-mv="' + v.id + '">−</span>' : '') + '</button>';
      }).join('') + '</div>' +
      '<button type="button" class="gg-btn ggx-pv-add" style="width:100%">+ add ' + esc(sv.title) + ' ✦ ' + money(P.price) + '</button>' +
      (cnt[sv.id] || calc(cart).n ? '<button type="button" class="ggx-pv-done">done ✦ back to my box</button>' : '');
    wireGal();
  }

  /* ── the game (Ali 2026-11-03): pick 2, the 2 gift slots unlock, pick them, win. Then one more unlocks a 3rd.
     The challenge stops at the 3rd free item; past that the discount still runs, quietly. ── */
  function stageOf(n) { return n < 4 ? 4 : 6; }
  function slotsHtml(r, big) {
    var T = stageOf(r.n), half = T / 2, f = r.free;
    var us = [];
    ((cart && cart.items) || []).forEach(function (it) {
      if (!(it.price > 0)) return;
      var fv = findVariant(it.variant_id);
      for (var q = 0; q < it.quantity; q++) us.push({ p: it.price, chip: fv && fv.v.chip });
    });
    us.sort(function (a, b) { return b.p - a.p; });            // what she pays for on the left, the gifts on the right
    var paid = us.slice(0, r.n - f), gifts = us.slice(r.n - f);
    var unlocked = paid.length >= half, h = '<span class="ggx-g-row">';
    for (var i = 0; i < half; i++) {
      var u = paid[i];
      h += '<span class="ggx-g-s' + (u ? ' in' : '') + '"' + (u && u.chip ? ' style="background-image:url(\'' + esc(u.chip) + '\')"' : '') + '></span>';
    }
    h += '<span class="ggx-g-plus">+</span>';
    for (var j = 0; j < half; j++) {
      var g = gifts[j];
      h += '<span class="ggx-g-s gift' + (g ? ' in' : (unlocked ? ' open' : ' lock')) + '"' + (g && g.chip ? ' style="background-image:url(\'' + esc(g.chip) + '\')"' : '') + '>' +
        (g ? '<em>free</em>' : (unlocked ? '🎁' : '🔒')) + '</span>';
    }
    return h + '</span>';
  }
  function gameMsg(r) {
    var n = r.n;
    if (n === 0) return { t: 'pick 2 ✦ unlock 2 <b>free</b> 🎁' };
    if (n === 1) return { t: '1 more ✦ unlock 2 <b>free</b> 🔓' };
    if (n === 2) return { t: '🔓 2 <b>free</b> unlocked ✦ pick them!', hot: true };
    if (n === 3) return { t: '🎁 1 more <b>free</b> item to pick!', hot: true };
    if (n === 4) return { t: '🎉 you won 2 <b>free</b> ✦ don’t leave your 3rd behind 🎁', win: true };
    if (n === 5) return { t: '🎁 your 3rd <b>free</b> item is waiting ✦ pick it!', hot: true };
    return { t: '🎉 you won ' + r.free + ' <b>free</b> ✦ saved ' + money(saved(r)), win: true };
  }
  var top;
  function buildTop() {
    top = document.createElement('div');
    top.id = 'ggx-top';
    var hdr = document.querySelector('.gg-sticky'), anchor = hdr ? (hdr.closest('.shopify-section') || hdr) : null;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(top, anchor.nextSibling); else document.body.insertBefore(top, document.body.firstChild);
    top.addEventListener('click', function () { if (calc(cart).n) openBag(); else goPick(); });
  }
  function drawTop() {
    if (!top) return;
    setTimeout(function () { document.documentElement.style.setProperty('--ggx-toph', top.offsetHeight + 'px'); }, 0);
    var r = calc(cart), pay = r.pay, pct = Math.max(3, Math.min(100, pay / GIFT_MIN * 100));
    var lab = pay >= GIFT_MIN ? '🚚 free delivery ✦ 🎁 free gift unlocked!' :
      pay >= SHIP_MIN ? '🚚 free delivery unlocked ✦ ' + money(GIFT_MIN - pay) + ' to a free gift' :
      'free delivery ✦ ' + money(SHIP_MIN - pay) + ' away ✦ free gift at ' + money(GIFT_MIN);
    var g = gameMsg(r);
    top.innerHTML =
      '<div class="ggx-meter"><span class="ggx-m-l">' + lab + '</span>' +
        '<span class="gg-meter ggx-m-bar"><span class="gg-meter-fill" style="width:' + pct + '%"><span class="gg-meter-kiss">💋</span></span>' +
        '<span class="ggx-mk" style="left:' + (SHIP_MIN / GIFT_MIN * 100) + '%">🚚</span><span class="ggx-mk" style="left:100%">🎁</span></span></div>' +
      (r.n > 6 ? '<div class="ggx-game win"><span class="ggx-g-t">' + g.t + '</span></div>' :
      '<div class="ggx-game' + (g.hot ? ' hot' : '') + (g.win ? ' win' : '') + '">' + slotsHtml(r) + '<span class="ggx-g-t">' + g.t + '</span></div>');
  }

  /* confetti + the win / unlock moments */
  function confetti() {
    var box = document.createElement('div'); box.className = 'ggx-confetti';
    var em = ['✨', '💖', '🎁', '💋', '✦', '🌸'];
    for (var i = 0; i < 28; i++) {
      var s = document.createElement('span');
      s.textContent = em[i % em.length];
      s.style.left = Math.random() * 100 + '%';
      s.style.animationDelay = Math.random() * .5 + 's';
      s.style.fontSize = 14 + Math.random() * 16 + 'px';
      box.appendChild(s);
    }
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 2600);
  }
  var modal;
  function showModal(html, buttons) {
    if (!modal) {
      modal = document.createElement('div'); modal.id = 'ggx-modal';
      modal.innerHTML = '<div class="ggx-md-bg"></div><div class="ggx-md-card"></div>';
      document.body.appendChild(modal);
      modal.querySelector('.ggx-md-bg').onclick = hideModal;
    }
    var card = modal.querySelector('.ggx-md-card');
    card.innerHTML = html + '<div class="ggx-md-btns">' + buttons.map(function (b, i) {
      return '<button type="button" class="' + (i ? 'ggx-md-no' : 'gg-btn ggx-md-yes') + '" data-i="' + i + '">' + b.label + '</button>';
    }).join('') + '</div>';
    card.querySelectorAll('[data-i]').forEach(function (el) { el.onclick = function () { buttons[+el.getAttribute('data-i')].go(el); }; });
    modal.classList.add('on');
    toastLock = Date.now() + 2400;
  }
  function hideModal() { if (modal) modal.classList.remove('on'); }
  function goPick() {
    hideModal(); closeBag();
    // stay exactly where she was (Ali 2026-11-04); only pages with nothing to pick send her to build your bag
    var t = document.getElementById('ggx-pick') || document.querySelector('[data-ggx-rows]');
    if (t) toast('🎁 <b>pick your free items</b> ✦ any shade, any product');
    else window.location.href = BUILD;
  }
  function goCheckout(el) { if (el) el.textContent = 'opening checkout ✦'; window.location.href = '/checkout'; }
  var lastN = null;
  function celebrate(prev, r) {
    if (prev === null || r.n <= prev) return;
    if (prev < 2 && r.n >= 2 && r.n < 4) { confetti(); toast('🔓 <b>2 free items unlocked!</b> pick them 🎁', true); }
    else if (prev < 4 && r.n >= 4 && r.n < 6) {
      confetti();
      showModal('<div class="ggx-md-k">you did it, gurl</div><div class="ggx-md-h">🎉 you won 2 <em>free</em> items!</div>' +
        '<div class="ggx-md-s">you saved <b>' + money(saved(r)) + '</b></div>' + slotsHtml(r) +
        '<div class="ggx-md-loss">don’t leave your 3rd free item behind 🎁</div>' +
        '<div class="ggx-md-next">add 1 more ✦ get 1 <b>FREE</b>' + (shipSure(cart) ? ' <b>+ free delivery 🚚</b>' : '') + '</div>',
        [{ label: 'claim my 3rd free item 🎁', go: goPick }, { label: 'no thanks, check out ✦ ' + money(r.pay) + (shipSure(cart) && shipOf(r) ? ' + ' + money(shipOf(r)) + ' delivery' : '') + ' →', go: goCheckout }]);
    }
    else if (prev < 5 && r.n === 5) { confetti(); toast('🔓 <b>3rd free item unlocked!</b> pick it 🎁', true); }
    else if (prev < 6 && r.n >= 6) {
      confetti();
      showModal('<div class="ggx-md-k">the full glow-up</div><div class="ggx-md-h">🎉 you won ' + r.free + ' <em>free</em> items!</div>' +
        '<div class="ggx-md-s">you saved <b>' + money(saved(r)) + '</b></div>',
        [{ label: 'check out ✦ ' + money(r.pay) + ' →', go: goCheckout }, { label: 'keep shopping', go: hideModal }]);
    }
  }
  /* checkout with a free item still waiting: say it loud, let her say no thanks */
  function gateCheckout(el) {
    var r = calc(cart), n = r.n, m = null;
    if (n === 1) m = ['wait gurl ✋', 'add 1 more and get <em>2 free</em> 🎁', 'add 1 more 🎁'];
    if (n === 2) m = ['wait gurl ✋', 'you have <em>2 free</em> items waiting 🎁', 'pick my 2 free items 🎁'];
    if (n === 3) m = ['almost ✋', 'you still have <em>1 free</em> item to pick 🎁', 'pick my free item 🎁'];
    if (n === 5) m = ['wait gurl ✋', 'don’t leave your <em>3rd free</em> item behind 🎁', 'claim my 3rd free item 🎁'];
    if (!m) return goCheckout(el);
    showModal('<div class="ggx-md-k">' + m[0] + '</div><div class="ggx-md-h">' + m[1] + '</div>' +
      (n >= 2 ? '<div class="ggx-md-s">they’re already yours ✦ just pick your shades</div>' : '<div class="ggx-md-s">buy 2, get 2 free ✦ mix any product, any shade</div>') + slotsHtml(r),
      [{ label: m[2], go: goPick }, { label: 'no thanks, check out →', go: goCheckout }]);
  }

  function drawAll() {
    var r = calc(cart);
    drawTop(); drawTray(); drawRows(); drawPick(); if (sheet && sheet.classList.contains('on')) drawBag();
    celebrate(lastN, r); lastN = r.n;
  }

  /* the product page's own "add to my bag" lands here instead of the old popups */
  window.GG_BN_ADDED = function () { refresh().then(function () { var r = calc(cart); toast('added to your bag ✦ <b>' + esc(line(r).big) + '</b>'); }); };
  window.GG_BN_BAG = function () { refresh().then(openBag); };
  // the theme's own checkout links (cart page) ask the same question before leaving
  window.GG_BN_GATE = function (c) {
    if (c) cart = c; var n = calc(cart).n;
    if (mysFor(n)) { openBag(); return true; }
    if ([1, 2, 3, 5].indexOf(n) < 0) return false; gateCheckout(null); return true;
  };
  /* the mystery lines exist only on the way to checkout: added there, cleared whenever she is back on the site */
  function checkoutWithMystery(btn, picks) {
    if (!picks.length) { gateCheckout(btn); return; }
    btn.disabled = true; btn.textContent = 'adding your free gifts ✦';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: picks.map(function (m) { return { id: m.id, quantity: 1 }; }) }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; btn.textContent = 'try again ✦'; });
  }
  function purgeMystery() {
    if (!cart || !cart.items) return Promise.resolve();
    var lns = cart.items.filter(isMys);
    if (!lns.length) return Promise.resolve();
    var upd = {}; lns.forEach(function (l) { upd[l.key] = 0; });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) }).then(refresh);
  }
  window.GG_BOX_OPEN = openBag;

  function boot() {
    document.body.classList.add('ggx');
    initPick();
    buildTop();
    buildTray();
    var prev = window.__ggAnnounceRefresh;
    window.__ggAnnounceRefresh = function () { if (prev) prev.apply(this, arguments); setTimeout(function () { fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; drawAll(); }); }, 30); };
    var bag = document.getElementById('gg-bag-btn');
    if (bag) bag.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); refresh().then(openBag); }, true);
    // back from checkout: the page may be restored from cache, so read the bag again
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().then(purgeMystery); });
    refresh().then(purgeMystery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
